import { Link, routes } from '@redwoodjs/router'
import { Toaster } from '@redwoodjs/web/toast'

type StrengthExerciseLayoutProps = {
  children: React.ReactNode
}

const StrengthExercisesLayout = ({ children }: StrengthExerciseLayoutProps) => {
  return (
    <div className="rw-scaffold">
      <Toaster />
      <header className="rw-header">
        <h1 className="rw-heading rw-heading-primary">
          <Link
            to={routes.strengthExercises()}
            className="rw-link"
          >
            StrengthExercises
          </Link>
        </h1>
        <Link
          to={routes.newStrengthExercise()}
          className="rw-button rw-button-green"
        >
          <div className="rw-button-icon">+</div> New StrengthExercise
        </Link>
      </header>
      <main className="rw-main">{children}</main>
    </div>
  )
}

export default StrengthExercisesLayout
